import { Component, h, Host, Listen, Prop } from "@stencil/core";
import { PrefillData } from "../../components";

@Component({
    tag: "mf-create-service-case-modal",
    shadow: false
})
export class CreateServiceCaseModal {
    // @ts-expect-error - modal is a HTMLUxModalElement
    private modal: HTMLUxModalElement;

    /**
     * Enable file upload in the form
     */
    @Prop() fileUpload: boolean = false;
    /**
     * data that should be prefilled in the form
     * @optional
     */
    @Prop() prefillData: PrefillData | null = null;
    /**
     * Identifier for the modal - see ux.ui docs
     */
    @Prop() modalName: string;
    /**
     * The locale to use for translations and the phone input
     */
    @Prop({ reflect: true }) locale: string = "en-US";
    /**
     * Environment string to decide which endpoints to use
     */
    @Prop() env: string = "prod";
    /**
     * use onprem Public API instead of azure
     * @deprecated only used until April 2025
     */
    @Prop() legacyApi: boolean = false;

    @Listen("mfServiceCaseSuccess")
    handleServiceCaseSuccess() {
        this.modal.triggerClose();
    }

    @Listen("mfServiceCaseCancel")
    handleServiceCaseCancel() {
        this.modal.triggerClose();
    }

    private handleModalClose = () => {
        window.location.reload();
    };

    render() {
        return (
            <Host>
                <ux-modal
                    onUxModalClose={() => this.handleModalClose()}
                    name={this.modalName}
                    ref={(el: HTMLElement) => (this.modal = el)}
                >
                    <ux-modal-content>
                        <mf-create-service-case
                            fileUpload={this.fileUpload}
                            prefillData={this.prefillData}
                            multipleSteps={true}
                            locale={this.locale}
                            env={this.env}
                            legacyApi={this.legacyApi}
                        >
                            <slot name="connector" />
                        </mf-create-service-case>
                    </ux-modal-content>
                </ux-modal>
            </Host>
        );
    }
}

export interface ProactiveCaseClosureModalProps {
    /** SIS case ID */
    callId: string;
    /**
     * The locale to use for translations
     */
    locale: string;
    /** Identifier for the modal - see ux.ui docs */
    modalName: string;
    /** Environment to use for API calls */
    env: string;
    /** use onprem Public API instead of azure */
    legacyApi: boolean;
    debug: boolean;
}
